import React from "react";
import styled from "styled-components";

const AdShareClassName = "xc449bad4854773ff";

const AdShareAdUnit = styled.div`
    background-color: white;
    margin: 30px auto;

    width: ${props => props.width};
    height: ${props => props.height};
`;

const LeaderboardAdUnit = styled(AdShareAdUnit)`
    @media (max-width: 991px) { display: none; }
`;

const LargeMobileBannerAdUnit = styled(AdShareAdUnit)`
    @media (max-width: 410px) { display: none; }
    @media (min-width: 992px) { display: none; }
`;

const ButtonTwoAdUnit = styled(AdShareAdUnit)`
    width: 120px;
    height: 60px;

    @media (min-width: 411px) { display: none; }
`;

const HalfBannerAdUnit = styled(AdShareAdUnit)`
    @media (min-width: 411px) { display: none; }
`;

const AdsharesBanner = () => (
    <>
        <LeaderboardAdUnit className={AdShareClassName} data-zone="2f47426e579a4e3a88712e15b2b753b7" width="728px" height="90px" />
        <LargeMobileBannerAdUnit className={AdShareClassName}  data-zone="955b08b899184ba097c910c34d739472" width="320px" height="100px"  />
        <HalfBannerAdUnit className={AdShareClassName} data-zone="2adad0670cd9449f97ad2801ac139471" width="234px" height="60px"  />
    </>
);

export default AdsharesBanner;